import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=6064762c&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=6064762c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064762c",
  null
  
)

export default component.exports